export default __webpack_public_path__ + "static/media/check-badge.e325855b.svg";